import { Component, OnInit } from '@angular/core';
import { BancoDeDadosService } from './banco-service/banco-de-dados.service';
import { MessageService } from 'primeng/api';

interface Banco {
  nomeBanco: string,
  bancoDados: string
}

@Component({
  selector: 'app-banco-de-dados',
  templateUrl: './banco-de-dados.component.html',
  styleUrls: ['./banco-de-dados.component.scss']
})

export class BancoDeDadosComponent implements OnInit {

  listaBancos: Banco[];
  BancoSelecionado: Banco;
  displayBasic: boolean = false;

  constructor(private service: BancoDeDadosService, private messageService: MessageService) { }

  ngOnInit() {
    this.service.listarBancos().then((res: any) => {
      this.listaBancos = res;
    });
  }

  atualizar() {
    this.service.alterarBanco(this.BancoSelecionado)
    this.displayBasic = false;
    sessionStorage.removeItem("currentUser");
    sessionStorage.removeItem("token");
    setInterval(function () { window.location.reload() }, 1000);
  }

  atualizarBanco() {
    if (this.BancoSelecionado == undefined) {
      this.messageService.add({
        severity: "error",
        summary: "Erro ao atualizar",
        detail: "Selecione um Banco de Dados para poder atualizar.",
      });
    } else {
      this.displayBasic = true;
    }
  }
}
